<script lang="ts" setup>
import type { Post } from "~~/sanity.types";

defineProps<{
  post: Post;
}>();
</script>

<template>
  <NuxtLink :to="`/blog/${post.slug?.current}`">
    <UCard
      :ui="{
        header: 'border-0 -mx-6 -my-4',
      }"
    >
      <template #header>
        <NuxtImg
          :src="post.img?.asset?._ref"
          :alt="post.img?.alt || post.title"
          width="360"
          height="230"
          provider="sanity"
          fit="cover"
          :modifiers="{
            crop: post.img?.crop,
            hotspot: post.img?.hotspot,
          }"
          class="w-full aspect-[16/10]"
          placeholder
        />
      </template>

      <div class="flex gap-1 items-center">
        <UBadge v-if="post.category" variant="soft">
          {{ postCategories[post.category] }}
        </UBadge>

        <span class="text-xs text-gray-400">•</span>

        <span class="text-xs text-gray-700 dark:text-gray-300">
          <NuxtTime
            :datetime="post.firstPublishedAt"
            year="numeric"
            month="long"
            day="numeric"
          />
        </span>
      </div>

      <h2 class="text-2xl font-semibold tracking-tight mt-3">
        {{ post.title }}
      </h2>

      <p class="text-base text-gray-700 dark:text-gray-300 mt-3">
        {{ post.description }}
      </p>
    </UCard>
  </NuxtLink>
</template>
